import { observable, action, makeObservable } from 'mobx';
import { InitializationError } from '../utils/errors';

class PriceDetails {
	isLoaded = false;

	customerCountryCode;
	planId;
	promotionId;
	discountId;
	lines = [];
	productName;
	planName;
	planFrequency;
	nextChargeDate;
	currentChargeDate;
	couponCode;

	constructor({ sumupService, customerCountryCode, vatNumber, zipCode, addressLine1, city, state, planId, couponCode, sumupSubscriptionsService, promotionId, discountId }) {
		makeObservable(this, {
			isLoaded: observable,
			customerCountryCode: observable,
			planId: observable,
			promotionId: observable,
			discountId: observable,
			lines: observable,
			productName: observable,
			planName: observable,
			planFrequency: observable,
			nextChargeDate: observable,
			currentChargeDate: observable,
			couponCode: observable,
			fetchPriceDetails: action
		});

		if (!sumupService || !sumupSubscriptionsService) {
			throw new InitializationError('sumupService and sumupSubscriptionsService should be provided');
		}

		this.sumupService = sumupService;
		this.sumupSubscriptionsService = sumupSubscriptionsService;

		Object.assign(this, {
			customerCountryCode, planId, promotionId, discountId, vatNumber, zipCode, addressLine1, city, state, couponCode,
		});
	}

	async fetchPriceDetails() {
		if (this.isLoaded) {
			return;
		}

		try {
			this.isLoaded = false;
			const result = await this.sumupSubscriptionsService.previewSubscriptionPurchase({
				planId: this.planId,
				vatNumber: this.vatNumber,
				customerCountryCode: this.customerCountryCode,
				zipCode: this.zipCode,
				addressLine1: this.addressLine1,
				city: this.city,
				state: this.state,
				couponCode: this.couponCode,
				promotionId: this.promotionId,
				discountId: this.discountId,
			});

			Object.assign(this, result);
			this.isLoaded = true;
		} catch (err) { // ignore error
			err.propagate();
			throw err;
		}
	}
}

export default PriceDetails;
